import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a0e356c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative","z-index":"2"} }
const _hoisted_2 = { style: {"position":"absolute","top":"-28px","left":"16px"} }
const _hoisted_3 = {
  class: "text--dark",
  style: {"font-size":"14px","font-weight":"700"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-divider" }, null, -1))
const _hoisted_5 = { class: "pb-1 flex w100" }
const _hoisted_6 = { class: "body-1 pt-1 ion-text-center" }
const _hoisted_7 = { class: "pb-1 flex w100" }
const _hoisted_8 = { class: "body-1 pt-1 ion-text-center" }
const _hoisted_9 = { class: "pb-1 flex w100" }
const _hoisted_10 = { class: "body-1 pt-1 ion-text-center" }
const _hoisted_11 = { class: "pb-1 flex w100" }
const _hoisted_12 = { class: "body-1 pt-1 ion-text-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-divider" }, null, -1))
const _hoisted_14 = { class: "pb-1 flex w100" }
const _hoisted_15 = { class: "body-1 pt-1 ion-text-center" }
const _hoisted_16 = { class: "pb-1 flex w100" }
const _hoisted_17 = {
  class: "body-1 pt-1 ion-text-center",
  style: {"font-size":"15px"}
}
const _hoisted_18 = { class: "pb-1 flex w100" }
const _hoisted_19 = { class: "body-1 pt-1 ion-text-center" }
const _hoisted_20 = { class: "pb-1 flex w100" }
const _hoisted_21 = {
  class: "body-1 pt-1 ion-text-center",
  style: {"font-size":"15px"}
}
const _hoisted_22 = { class: "pb-1 flex w100" }
const _hoisted_23 = { class: "body-1 pt-1 ion-text-center" }
const _hoisted_24 = { class: "pb-1 flex w100" }
const _hoisted_25 = { class: "body-1 pt-1 ion-text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_backdrop = _resolveComponent("ion-backdrop")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_yrp_circle_logo = _resolveComponent("yrp-circle-logo")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_circle_progress = _resolveComponent("circle-progress")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_ion_backdrop, null, null, 512), [
      [_vShow, _ctx.isOpen]
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ion_fab_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => {
          _ctx.$emit('openCheck');
          _ctx.isOpen = false;
          _ctx.$router.push('/home/dashboard');
          _ctx.triggerScrollTop();
        })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_icon, { icon: _ctx.checkmarkCircleOutline }, null, 8, ["icon"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", {
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isOpen = !_ctx.isOpen)),
        class: _normalizeClass(["w100 ion-text-end ion-activatable my-pointer py-2", _ctx.isOpen ? 'open-cool' : 'not-open-cool'])
      }, [
        _createVNode(_component_ion_button, {
          fill: "clear",
          disabled: "",
          style: {"opacity":"1"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("strong", _hoisted_3, _toDisplayString(_ctx.pageName), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_ion_button, { fill: "none" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_ripple_effect),
            _createVNode(_component_ion_icon, {
              size: "large",
              icon: _ctx.isOpen ? _ctx.closeOutline : _ctx.menuOutline
            }, null, 8, ["icon"])
          ]),
          _: 1
        }),
        _createVNode(_component_ion_grid, { class: "w100 pa-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_row, {
              class: "ion-justify-content-center ion-no-padding",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$router.push('/home/dashboard'); _ctx.triggerScrollTop();})
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_ion_col, {
                  class: "ion-no-padding ion-text-center flex-column",
                  size: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_yrp_circle_logo, {
                      class: "my-pointer",
                      style: {"height":"72px"}
                    }),
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t("menu.home")), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.isOpen]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, { size: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$router.push('/home/bio'); _ctx.triggerScrollTop();}),
                      button: "",
                      class: "my-pointer",
                      lines: "none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_circle_progress, {
                                class: "auto",
                                "border-width": 6,
                                "border-bg-width": 6,
                                "empty-color": "#c6d6dc",
                                "fill-color": "#99ca3c",
                                size: 32,
                                percent: _ctx.latestCheckIn ? _ctx.latestCheckIn.biological : 0
                              }, null, 8, ["percent"])
                            ]),
                            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("menu.bio")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, { size: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$router.push('/home/psych'); _ctx.triggerScrollTop();}),
                      button: "",
                      class: "my-pointer",
                      lines: "none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_circle_progress, {
                                class: "auto",
                                "border-width": 6,
                                "border-bg-width": 6,
                                "empty-color": "#c6d6dc",
                                "fill-color": "#58c4eb",
                                size: 32,
                                percent: _ctx.latestCheckIn ? _ctx.latestCheckIn.psychological : 0
                              }, null, 8, ["percent"])
                            ]),
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("menu.psych")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, { size: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$router.push('/home/social'); _ctx.triggerScrollTop();}),
                      button: "",
                      class: "my-pointer",
                      lines: "none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_circle_progress, {
                                class: "auto",
                                "border-width": 6,
                                "border-bg-width": 6,
                                "empty-color": "#c6d6dc",
                                "fill-color": "#f47b4b",
                                size: 32,
                                percent: _ctx.latestCheckIn ? _ctx.latestCheckIn.social : 0
                              }, null, 8, ["percent"])
                            ]),
                            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("menu.social")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, { size: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$router.push('/home/spirit'); _ctx.triggerScrollTop();}),
                      button: "",
                      class: "my-pointer flex-column",
                      lines: "none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_circle_progress, {
                                class: "auto",
                                "border-width": 6,
                                "border-bg-width": 6,
                                "empty-color": "#c6d6dc",
                                "fill-color": "#9a57a3",
                                size: 32,
                                percent: _ctx.latestCheckIn ? _ctx.latestCheckIn.spiritual : 0
                              }, null, 8, ["percent"])
                            ]),
                            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("menu.spirit")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }),
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, { size: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      button: "",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$router.push('/home/search'); _ctx.triggerScrollTop();}),
                      class: "my-pointer",
                      lines: "none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_ion_icon, {
                                class: "auto",
                                size: "large",
                                icon: _ctx.searchOutline
                              }, null, 8, ["icon"])
                            ]),
                            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("menu.search")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, { size: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      button: "",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.$router.push('/home/contacts'); _ctx.triggerScrollTop();}),
                      class: "my-pointer",
                      lines: "none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_ion_icon, {
                                class: "auto",
                                size: "large",
                                icon: _ctx.peopleOutline
                              }, null, 8, ["icon"])
                            ]),
                            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("menu.resources")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, { size: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      button: "",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.$router.push('/home/events'); _ctx.triggerScrollTop();}),
                      class: "my-pointer",
                      lines: "none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(_component_ion_icon, {
                                class: "auto",
                                size: "large",
                                icon: _ctx.calendarOutline
                              }, null, 8, ["icon"])
                            ]),
                            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("menu.events")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, { size: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      button: "",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('openDistress'))),
                      class: "my-pointer",
                      lines: "none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_ion_icon, {
                                class: "auto",
                                size: "large",
                                icon: _ctx.helpBuoyOutline
                              }, null, 8, ["icon"])
                            ]),
                            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("menu.help")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, { size: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      button: "",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.$router.push('/home/settings'); _ctx.triggerScrollTop();}),
                      class: "my-pointer",
                      lines: "none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_ion_icon, {
                                class: "auto",
                                size: "large",
                                icon: _ctx.settingsOutline
                              }, null, 8, ["icon"])
                            ]),
                            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("menu.settings")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, { size: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.logout())),
                      button: "",
                      class: "my-pointer",
                      lines: "none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(_component_ion_icon, {
                                class: "auto",
                                size: "large",
                                icon: _ctx.logOutOutline
                              }, null, 8, ["icon"])
                            ]),
                            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("menu.logout")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 2)
    ])
  ], 64))
}